import React, { useContext, useMemo } from 'react'
import classNames from 'classnames'
import styles from './OverviewV2.module.scss'
import OverviewCompanyHeader from './OverviewCompanyHeader'
import { OverviewV2Props } from './types'
import { VerticalContext } from 'store/verticals/Context'
import { buildMetaItemsFromMapping } from './utils'

const OverviewV2Container = ({ overviewMapping, breadcrumbs, children, className, descriptor }: OverviewV2Props) => {
  const { verticalEntity } = useContext(VerticalContext)
  const { statusItem, otherMetaItems } = useMemo(() => {
    const computedMetaItems = buildMetaItemsFromMapping(
      overviewMapping,
      {
        ...(verticalEntity?.entityDetails ? verticalEntity?.entityDetails : {}),
        ...(verticalEntity?.overviewDetails ? verticalEntity?.overviewDetails : {}),
        ...(verticalEntity?.aggregatedTotals ? verticalEntity?.aggregatedTotals : {}),
      },
      verticalEntity,
    )
    const statusItem = computedMetaItems.find(item => item.label.toLowerCase() === 'status')
    const otherMetaItems = computedMetaItems.filter(item => item.label.toLowerCase() !== 'status')
    return { statusItem, otherMetaItems }
  }, [overviewMapping, verticalEntity])

  return (
    <div className={classNames(styles.container, className)}>
      {breadcrumbs ? breadcrumbs : null}
      <OverviewCompanyHeader
        name={verticalEntity?.entityDetails?.name}
        image={verticalEntity?.entityDetails?.image}
        about={verticalEntity?.overviewDetails?.about}
        status={statusItem}
        descriptor={Array.isArray(descriptor) ? descriptor.join(', ') : descriptor}
        metaItems={otherMetaItems}
      />
      {children}
    </div>
  )
}

export const OverviewV2 = React.memo(OverviewV2Container)
